import React, { useState, Suspense, useEffect } from 'react';
import CoursesDataProvider from '../../../Utils/Courses/CoursesDataProvider';
const EachComponent = React.lazy(
  () => import('../../../Components/Entity/EachComponent.component')
);
const SearchCourses = React.lazy(
  () => import('./SearchCoursesComponent.component')
);
import EntityLoader from '../../../Components/LoadingPages/LoadingEntity.component';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
import { MobileAdminDataContainer } from '../AdminStyles.styles';
import BreadCrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { useMediaQuery } from 'react-responsive';
const CoursesTab = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [allCourses, setAllCourses] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!allCourses?.length) return;

    const filteredCourses = allCourses?.filter((course) =>
      course?.courseName?.toLowerCase().includes(search?.toLowerCase())
    );

    setFiltered(filteredCourses);

    if (!filteredCourses.length) {
      setErr('No courses found');
    } else {
      setErr('');
    }
  }, [search, allCourses]);

  return (
    <Suspense fallback={<EntityLoader />}>
      <MobileAdminDataContainer>
        {isMobile && (
          <>
            <HelmetHelper title="Courses" description="Courses" />
            <BreadCrumbs
              one="Admin  Dashboard"
              oneLink="/admin"
              two="Courses"
            />
          </>
        )}
        <CoursesDataProvider>
          {(courses) => {
            return (
              <section>
                <h3 className="m1B">COURSES</h3>
                <SearchCourses
                  courses={courses}
                  setFiltered={setFiltered}
                  setSearch={setSearch}
                  setErr={setErr}
                  setAllCourses={setAllCourses}
                />
                {err && <p className="error">{err}</p>}
                {filtered?.map((c) => (
                  <EachComponent
                    key={c?._id}
                    name={c?.courseName}
                    route={`/admin/edit-course/${c?._id}`}
                  />
                ))}
              </section>
            );
          }}
        </CoursesDataProvider>
      </MobileAdminDataContainer>
    </Suspense>
  );
};

export default CoursesTab;
